export default class FormularioRespuesta {
    constructor(
        public numPresolicitud : number = 0,
        public idPregunta : number = 0,
        public ResponseValue:string = "",
        public idReiterativo: number =1
    ){
        
    }
}